<template>
  <Layout class="container">
    <PageHeader :title="title" :items="items" />
    <div class="row " v-if="order">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form role="form" class="form-horizontal">
              <Input v-model.trim="order.company" label="Firma" />
              <div class="form-row form-group mt-4 mb-2" >
                <label class="col-lg-2 col-form-label"
                >Anrede</label>
                <div class="col">
                  <multiselect v-model="order.gender" :options="genderOptions" class="helo"></multiselect>
                </div>
              </div>
              <Input v-model.trim="order.firstname" label="Vorname" />
              <Input v-model.trim="order.name" label="Name" />
              <Input v-model.trim="order.address" label="Adresse" />
              <Input v-model.trim="order.address2" label="Adresse 2" />
              <Input v-model.trim="order.zip" label="PLZ" type="number" />
              <Input v-model.trim="order.city" label="Ort" />
              <Input v-model.trim="order.phone" label="Telefon" />
              <Input v-model.trim="order.email" label="E-Mail" />
              <!-- Select Status Start -->
              <div class="form-row form-group mb-3" >
                <label class="col-lg-2 col-form-label"
                >Status</label>
                <div class="col">
                  <multiselect v-model="order.status" :options="statusOptions" class="helo"></multiselect>
                </div>
              </div>
              <!-- Select Status End -->
              <Input v-model.trim="order.category" label="Kategorie" />

              <Input v-model.trim="order.parkingCount" label="Parktickets" type="number" />
              <h5>Tickets</h5>
              <Input v-model.trim="order.amount" label="Bestellt" type="number" />
              <Input v-model.trim="order.capacity" label="Kontingent" type="number" />

              <Input v-model.trim="order.comments2" label="Bemerkungen" type="text" />
              <Input v-model.trim="order.notes2" label="Notizen" type="text" />

              <div class="row justify-content-end">
                <div class="col-10">
                  <div>
                    <b-button type="button" class="btn btn-danger" @click="saveOrder">Speichern</b-button> <b-button type="button" class="btn btn-warning" @click="saveAndTicketOrder">Speichern & Tickets auswählen</b-button>

                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row " v-if="order && !create">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-2">Order Date:</div>
              <div class="col-10">{{ order.orderDate | formatDateTime }}</div>
            </div>
            <div class="row">
              <div class="col-2">Seen Date:</div>
              <div class="col-10">{{ order.seenDate | formatDateTime }}</div>
            </div>
            <div class="row">
              <div class="col-2">Shipment Date:</div>
              <div class="col-10">{{ order.shipmentDate | formatDateTime }}</div>
            </div>
            <div class="row">
              <div class="col-2">Order-ID:</div>
              <div class="col-10">({{order.id}}) {{order.orderId }}</div>
            </div>
            <div class="row mt-3">
              <div class="col-2"><b-button class="btn btn-danger" @click="deleteOrder">Delete Order</b-button> </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Repository from "@/repositories/RepositoryFactory";
const OrderRepository = Repository.get("orders");

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Input from "@/components/form/Input";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

/**
 * Ticket Orders Component
 */
export default {
  page: {
    title: "Ticket Orders",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Multiselect,
    Layout,
    PageHeader,
    Input,
  },
  props: ['id'],
  data() {
    return {
      title: "Ticket Order",
      items: [
        {
          text: "Ticket Orders",
          href: "/orders",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      create: false,
      order: {},
      statusOptions: [
        "NOTSET",
        "CREATED",
        "INVITED",
        "ORDERED",
        "REVIEW",
        "READY",
        "SHIPPED",
        "DELETED",
        "ARCHIVED",
        "CANCELLED",
      ],
      genderOptions: [
          "NOTSET",
          "HERR",
          "FRAU",
      ],
    };
  },
  computed: {

  },
  created() {
    if(this.id){
      this.getOrder();
    } else {
      this.create = true;
      this.order = { };
    }
  },
  mounted() {

  },
  methods: {
    saveOrder(){
      if(this.create){
        OrderRepository.create(this.order).then(() => {
          this.$router.push({ name: "orders"});
        }).catch((err)=>{
          Swal.fire("Error", err, "error");
        });
      } else {
        OrderRepository.update(this.order, this.order.id).then(() => {
          this.$router.push({ name: "orders"});
        }).catch((err)=>{
          Swal.fire("Error", err, "error");
        });
      }
    },
    saveAndTicketOrder(){
      if(this.create){
        OrderRepository.create(this.order).then((data) => {
          this.$router.push({ name: "orders-seatmap-id", params: {id: data.data.id}});
        }).catch((err)=>{
          Swal.fire("Error", err, "error");
        });
      } else {
        OrderRepository.update(this.order, this.order.id).then(() => {
          this.$router.push({ name: "orders-seatmap-id", params: {id: this.order.id}});
        }).catch((err)=>{
          Swal.fire("Error", err, "error");
        });
      }
    },

    deleteOrder() {
      Swal.fire({
        title: "Are you sure?",
        text: 'You want to delete '+(this.order.company+", " || "")+(this.order.firstname+" " || "")+(this.order.name || "")+'?',
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          OrderRepository.delete(this.id).then(() => {
            Swal.fire("Deleted!", "Your file has been deleted.", "success").then(()=>{
              this.$router.push({ name: "orders"});
            });
          }).catch((err) => {
            Swal.fire("Error", err, "error");
          });
        }
      });
    },
    getOrder: async function() {
      const { data } = await OrderRepository.get(this.id);
      this.order = data;
    },
  },
};
</script>